import React, { useEffect, useState } from "react";
import { Container } from "../../components";
import { Icon, Heading } from "@telia/teddy";
import { connect } from "react-redux";
import WaitQueuePageRoot from "./WaitQueuePageRoot";
import { FinancingType } from "../../../../constants";
import { GetCustomerType, OfferingCode, RootState } from "../../../../models";
import { isRunningOnClientSide } from "../../../../shared/util";
import QueueContinueButton from "../components/atoms/QueueContinueButton";
import * as QUEUE_DATA_SELECTORS from "../state/selectors/queueDataSelector";

interface QueueProps {
    customerTypeGet: GetCustomerType;
    discountCode: string;
    enableCheckoutQueue: boolean;
    financingDuration: string;
    financingType: FinancingType;
    pricePlan: OfferingCode;
    returnUrl: string;
    sku: string;
}

const Queue: React.FC<QueueProps> = (props) => {
    const [hasCookie, setHasCookie] = useState(false);

    useEffect(() => {
        if (isRunningOnClientSide()) {
            if (document.cookie.includes("queueData")) {
                setHasCookie(true);
            }
        }
    }, []);

    if (hasCookie && props.enableCheckoutQueue) {
        return (
            <WaitQueuePageRoot>
                <Container style={{ textAlign: "center" }} size="medium">
                    <Heading mb="100" as="h1" variant="title-600">
                        {"Det er din tur"}
                    </Heading>
                    <div className="more-info__container">
                        <Icon name="like" className="more-info__like-icon" />
                    </div>
                    <div>
                        <QueueContinueButton {...props} />
                    </div>
                </Container>
            </WaitQueuePageRoot>
        );
    }

    return (
        <Container style={{ textAlign: "center" }} size="medium">
            <Heading mb="100" as="h1" variant="title-600">
                {"Det er din tur"}
            </Heading>
            <div className="more-info__container">
                <Icon name="like" className="more-info__like-icon" />
            </div>
            <div>
                <QueueContinueButton {...props} />
            </div>
        </Container>
    );
};

const mapStateToProps = (state: RootState) => ({
    sku: QUEUE_DATA_SELECTORS.getSku(state),
    financingType: QUEUE_DATA_SELECTORS.getFinancingType(state),
    financingDuration: QUEUE_DATA_SELECTORS.getFinancingDuration(state),
    discountCode: QUEUE_DATA_SELECTORS.getDiscountCode(state),
    pricePlan: QUEUE_DATA_SELECTORS.getPricePlan(state),
    returnUrl: QUEUE_DATA_SELECTORS.getReturnUrl(state),
    customerTypeGet: QUEUE_DATA_SELECTORS.getCustomerTypeGet(state),
    enableCheckoutQueue: QUEUE_DATA_SELECTORS.getEnableCheckoutQueue(state),
});

export default connect(mapStateToProps)(Queue);
